import React, {useState,useContext, useEffect} from 'react';
import {Button, InputDropZone, InputEditQuill, Select, SelectGruposEsp, SelectMotivoIng, TabCierreExterno} from '@app/components/index';
import { Tabs, Tab, Modal,Button as Btn} from 'react-bootstrap';
import TicketService from '@app/services/tickets.service';
import {toast} from 'react-toastify';
import Compressor from 'compressorjs';
import { SocketContext } from '../../context/SocketContext';


function ModalCierreTicket({show, hideModal, ticketId,onGuardar}) {
    const [isLoading, setIsLoading] = useState(false);
    const handleClose = () => hideModal();
    const [cierre, setCierre] = useState('CONECTIVIDAD')
    const [tipoResolucion, setTipoResolucion] = useState('REMOTO')
    const [tipoResolucionEmp, setTipoResolucionEmp] = useState(null)
    const [motivoFalla, setMotivoFalla] = useState(12)
    const [motivoFallaNombre, setMotivoFallaNombre] = useState('OTRO')
    const { sockets } = useContext( SocketContext );
    const [comentario, setComentario] = useState()
    const [key, setKey] = useState('correcto');
    const [foto, setFoto] = useState()
    const [foto2, setFoto2] = useState()
    const [foto3, setFoto3] = useState()
    const extensionPermitida = ['png','jpg','jpeg','svg','x-png'];
    const acceptInputFile = 'image/jpeg, image/png, image/jpg, image/svg, image/x-png, video/*,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

    const onSubmit = () =>{
        if(comentario && comentario.length > 8){
            const form={
                id_tk: ticketId,
                contratoNubi_tk: cierre,
                comentarioCierre: comentario,
                type: 'cvv',
                tipoRes_dtk: tipoResolucion,
                empRes_dtk: tipoResolucionEmp,
                motivoIngId_dtk: motivoFalla,
                motivoIngNombre_dtk: motivoFallaNombre,
            }
            if(foto){
                form.foto = foto;
            }
            if(foto2){
                form.foto2 = foto2;
            }
            if(foto3){
                form.foto3 = foto3;
            }
            setIsLoading(true);
            TicketService.cerrarTicket(form).then(()=>{
                sockets?.emit( 'ticketRefresh', `cvv${ticketId}` );
                onGuardar();
                hideModal();
            })
            .finally(()=>{
                setIsLoading(false);
            })
        }else{
            toast.error('Falta el comentario', {
                position: "top-right",
                autoClose: 2500,
                pauseOnHover: false,
            });
        }
    }
    useEffect(() => {
        if(foto?.length > 0){
            const {name,size} = foto[0];
            if(size > 20000000){
                setFoto(null)
            }else{
                const nombreCortado = name.split('.');
                let extension = nombreCortado[ nombreCortado.length - 1 ];
                extension = extension.toLowerCase();
                if(extensionPermitida.includes( extension ) ){
                    setIsLoading(true);
                    const img = new Compressor(foto[0], {
                        quality: 0.3,
                        convertSize:2000000,
                        success(result) {
                            setIsLoading(false);
                            setFoto(result);
                        }
                    })
                }
            }
        }
    }, [foto])

    useEffect(() => {
        if(foto2?.length > 0){
            const {name,size} = foto2[0];
            if(size > 20000000){
                setFoto2(null)
            }else{
                const nombreCortado = name.split('.');
                let extension = nombreCortado[ nombreCortado.length - 1 ];
                extension = extension.toLowerCase();
                if(extensionPermitida.includes( extension ) ){
                    setIsLoading(true);
                    const img = new Compressor(foto2[0], {
                        quality: 0.3,
                        convertSize:2000000,
                        success(result) {
                            setIsLoading(false);
                            setFoto2(result);
                        }
                    })
                }
            }
        }
    }, [foto2])
    useEffect(() => {
        if(foto3?.length > 0){
            const {name,size} = foto3[0];
            if(size > 20000000){
                setFoto3(null)
            }else{
                const nombreCortado = name.split('.');
                let extension = nombreCortado[ nombreCortado.length - 1 ];
                extension = extension.toLowerCase();
                if(extensionPermitida.includes( extension ) ){
                    setIsLoading(true);
                    const img = new Compressor(foto3[0], {
                        quality: 0.3,
                        convertSize:2000000,
                        success(result) {
                            setIsLoading(false);
                            setFoto3(result);
                        }
                    })
                }
            }
        }
    }, [foto3])
    return (
        <Modal show={show} backdrop="static" onHide={handleClose} size='xl'>
            <Modal.Header closeButton>
                <Modal.Title>
                    {`¿Esta seguro de cerrar el Ticket #${ticketId}?`}
                </Modal.Title>
            </Modal.Header>
                <Tabs
                    id="contactosTab"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    <Tab eventKey="correcto" title="Ticket Valido" tabClassName="card-body">
                        <div className="p-3">

                            {/* Sección: Datos de resolución */}
                            <div className="card mb-3 border-0 shadow-sm">
                                <div className="card-body">
                                    <h6 className="text-muted text-uppercase mb-3" style={{letterSpacing:'1px', fontSize:'12px'}}>
                                        <i className="fas fa-tools mr-2" />
                                        Datos de resolución
                                    </h6>
                                    <div className="row">
                                        <div className="col-12 col-md-3 mb-3">
                                            <label className="label-control font-weight-bold" style={{fontSize:'13px'}}>
                                                Modo de resolución
                                            </label>
                                            <Select
                                                defaultValue={tipoResolucion}
                                                onChange={(opt) => setTipoResolucion(opt?.value || null)}
                                                options={[
                                                    { label: 'INSITU', value: 'INSITU' },
                                                    { label: 'REMOTO', value: 'REMOTO' },
                                                ]}
                                            />
                                        </div>
                                        <div className="col-12 col-md-3 mb-3">
                                            <label className="label-control font-weight-bold" style={{fontSize:'13px'}}>
                                                Área
                                            </label>
                                            <SelectGruposEsp
                                                id="selectGrupo2"
                                                contactoId={tipoResolucionEmp}
                                                onChange={(opt) => setTipoResolucionEmp(opt.value)}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 mb-3">
                                            <label className="label-control font-weight-bold" style={{fontSize:'13px'}}>
                                                Motivo de falla
                                            </label>
                                            <SelectMotivoIng
                                                id="selectmotivofalla"
                                                value={motivoFalla}
                                                onChange={(opt) => {
                                                    setMotivoFalla(opt?.value || null)
                                                    setMotivoFallaNombre(opt?.label || null)
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Sección: Contrato */}
                            <div className="card mb-3 border-0 shadow-sm">
                                <div className="card-body">
                                    <h6 className="text-muted text-uppercase mb-3" style={{letterSpacing:'1px', fontSize:'12px'}}>
                                        <i className="fas fa-file-contract mr-2" />
                                        Contrato de cierre
                                    </h6>
                                    <div className="row">
                                        <div className="col-6">
                                            <Btn
                                                block
                                                variant={cierre === 'CONECTIVIDAD' ? 'danger' : 'outline-danger'}
                                                style={{borderRadius:'8px', fontWeight:'600'}}
                                                onClick={() => setCierre('CONECTIVIDAD')}
                                            >
                                                <i className="fas fa-wifi mr-2" />
                                                CONECTIVIDAD
                                            </Btn>
                                        </div>
                                        <div className="col-6">
                                            <Btn
                                                block
                                                variant={cierre === 'MANTENIMIENTO' ? 'danger' : 'outline-danger'}
                                                style={{borderRadius:'8px', fontWeight:'600'}}
                                                onClick={() => setCierre('MANTENIMIENTO')}
                                            >
                                                <i className="fas fa-wrench mr-2" />
                                                MANTENIMIENTO
                                            </Btn>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Sección: Comentario y archivos */}
                            <div className="card mb-3 border-0 shadow-sm">
                                <div className="card-body">
                                    <h6 className="text-muted text-uppercase mb-3" style={{letterSpacing:'1px', fontSize:'12px'}}>
                                        <i className="fas fa-comment-alt mr-2" />
                                        Comentario de cierre
                                    </h6>
                                    <InputEditQuill
                                        id={1}
                                        template=""
                                        onChangeText={(html) => setComentario(html)}
                                    />
                                    <div className="mt-3">
                                        <p className="text-muted mb-2" style={{fontSize:'12px'}}>
                                            <i className="fas fa-paperclip mr-1" />
                                            Adjuntos (máx. 20 MB por archivo)
                                        </p>
                                        <div className="d-flex" style={{gap:'12px'}}>
                                            <div className="video-holder">
                                                <InputDropZone
                                                    id="fotos1"
                                                    accept={acceptInputFile}
                                                    defaultImage={foto}
                                                    backgroundImage="fileUpload"
                                                    onChange={setFoto}
                                                    setFoto={setFoto}
                                                />
                                            </div>
                                            <div className="image-holder">
                                                <InputDropZone
                                                    id="fotos2"
                                                    accept={acceptInputFile}
                                                    defaultImage={foto2}
                                                    backgroundImage="fileUpload"
                                                    onChange={setFoto2}
                                                    setFoto={setFoto2}
                                                />
                                            </div>
                                            <div className="image-holder">
                                                <InputDropZone
                                                    id="fotos3"
                                                    accept={acceptInputFile}
                                                    defaultImage={foto3}
                                                    backgroundImage="fileUpload"
                                                    onChange={setFoto3}
                                                    setFoto={setFoto3}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Acciones */}
                            <div className="d-flex justify-content-end" style={{gap:'8px'}}>
                                <Button theme="default" size="xl" onClick={handleClose}>
                                    <i className="fas fa-times mr-1" />
                                    Cancelar
                                </Button>
                                <Button
                                    size="xl"
                                    theme="danger"
                                    onClick={onSubmit}
                                    isLoading={isLoading}
                                >
                                    <i className="fas fa-lock mr-1" />
                                    Cerrar Ticket
                                </Button>
                            </div>

                        </div>
                    </Tab>
                    <Tab eventKey="incidenteexterno" title="Incidente Externo" tabClassName="card-body">
                        <TabCierreExterno ticketId={ticketId} hideModal={hideModal} onGuardar={onGuardar} />
                    </Tab>
                </Tabs>
        
        </Modal>
    );
}
export default ModalCierreTicket;